module.exports = __webpack_public_path__ + "assets/img/logo-black.009418e3.png";